import { LacertaMetaFields } from './meta.model';
import { LacertaWagtailPage } from '@lacerta/cms';

export class LacertaMetaConfig<TPage extends LacertaWagtailPage = LacertaWagtailPage> {
  customPageMetaMappings?: [string, (page: TPage) => LacertaMetaFields][];
}
